import { Text, TextProps } from '@chakra-ui/react';
import * as React from 'react';

import { Semibold } from '@/imports/ui/chakra/components/Semibold';

import { ICommentAtMentionData } from '../../types';

type ICommentAtMentionTextContentProps = {
  data: ICommentAtMentionData;
} & TextProps;

export const CommentAtMentionTextContent: React.FC<
  ICommentAtMentionTextContentProps
> = (props) => {
  const { data, ...rest } = props;

  return (
    <Text {...rest}>
      <Semibold>{data.firstActor.displayName}</Semibold>{' '}
      {data.numUniqueCommenters > 1
        ? `and ${data.numUniqueCommenters - 1} other${
            data.numUniqueCommenters > 2 ? 's' : ''
          } `
        : ''}
      mentioned you in comment
      <Semibold>{`${
        data.comment.bodyPlainText ? `: ${data.comment.bodyPlainText}` : ''
      }`}</Semibold>
    </Text>
  );
};
